import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <h1 className="title">Contacts</h1>
      <ul className="menu">
        <li className="menuItem">
          <Link to="/" className="menuLink">
            Imports
          </Link>
        </li>
        <li className="menuItem">
          <Link to="/contacts" className="menuLink">
            Contacts
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
